import React from "react";
import { NavLink } from "react-router-dom";
import Testimonials from "../../components/home/Testimonials";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import LinkProfsImage from "../../assets/images/Linkedin-ext/link-profs.png";
import LinkBannerOnpageImage from "../../assets/images/Linkedin-ext/link-banner-onpage.png";
import CustomOutreach from "../../assets/images/Linkedin-ext/custom-outreach.png";
import RealTimeSync from "../../assets/images/Linkedin-ext/real-time-sync.png";
import AdvanceSearchFilter from "../../assets/images/Linkedin-ext/advance-search-filter.png";
import InstantLeadCapture from "../../assets/images/Linkedin-ext/instant_lead_capture.png";
import ProfileInsights from "../../assets/images/Linkedin-ext/profile-insights.png";
import Cta from "../../components/cta/cta";

const LinkedingExtPage = () => {
  const customGridTemplateColumns = "repeat(2, 1fr)";
  return (
    <>
      <div className="linkedin-ext-wrapper">
        <section className="linkd-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <h1 className="heading39px roboto-bold mb20 text-color-131415">
                  Effortlessly Connect with <br /> the Right Professionals on
                  LinkedIn
                </h1>
                <p className="heading16px roboto-regular mb30 text-color-131415">
                  LinkedIn is the go-to platform for professional networking,
                  and with BeyondLeadz's <br /> LinkedIn Extension, tapping into
                  this vast network is easier than ever.
                </p>
                <ul className="btn-sec mb30">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Subscribe Now
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/contact-us"}
                      className="common-btn-class transparentBtn roboto-regular"
                    >
                      Contact us
                    </NavLink>
                  </li>
                </ul>

                <p className="heading16px roboto-regular mb30 text-color-131415">
                  TRUSTED BY 10,000+ LINKEDIN EXPERTS, FOUNDERS, MARKETERS AND
                  PROFESSIONALS
                </p>

                <img
                  src={LinkProfsImage}
                  className="img-responsive mb40"
                  alt="Effortlessly Connect with the Right Professionals on LinkedIn"
                />

                <img
                  src={LinkBannerOnpageImage}
                  className="img-responsive"
                  alt="Effortlessly Connect with the Right Professionals on LinkedIn"
                />
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="linkd-three _border-bottom">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb10 heading29px mb40 text-center">
                All-in-One <span style={{ color: "#0077B5" }}>Linkedin</span>{" "}
                Tool to Grow Your Business
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": customGridTemplateColumns,
                  "--grid-gap": "24px",
                }}
              >
                <div className="common-shadow common-box">
                  <h3 className="roboto-bold heading20px mb10">
                    Instant Lead Capture
                  </h3>
                  <p className="roboto-regular heading16px">
                    Quickly capture and import lead information from LinkedIn
                    profiles directly into your BeyondLeadz's dashboard with a
                    single click.
                  </p>

                  <img
                    src={InstantLeadCapture}
                    loading="lazy"
                    class="img-responsive position-relative mt30"
                    alt="Instant Lead Capture"
                  />
                </div>

                <div className="common-shadow common-box">
                  <h3 className="roboto-bold heading20px mb10">
                    Profile Insights
                  </h3>
                  <p className="roboto-regular heading16px">
                    Access detailed information about your LinkedIn prospects,
                    including job titles, company details, and mutual
                    connections, all in one place.
                  </p>

                  <img
                    src={ProfileInsights}
                    loading="lazy"
                    class="img-responsive position-relative mt30"
                    alt="Profile Insights"
                  />
                </div>

                <div className="common-shadow common-box">
                  <h3 className="roboto-bold heading20px mb10">
                    Custom Outreach
                  </h3>
                  <p className="roboto-regular heading16px">
                    Use enriched data to personalize your connection requests
                    and messages, increasing your chances of building meaningful
                    professional relationships.
                  </p>

                  <img
                    src={CustomOutreach}
                    class="img-responsive position-relative mt30"
                    loading="lazy"
                    alt="Custom Outreach"
                  />
                </div>

                <div className="common-shadow common-box">
                  <h3 className="roboto-bold heading20px mb10">
                    Real-Time Syncing
                  </h3>
                  <p className="roboto-regular heading16px">
                    Automatically sync LinkedIn lead data with your CRM and
                    marketing automation tools, ensuring that your lead database
                    is always up to date.
                  </p>

                  <img
                    src={RealTimeSync}
                    class="img-responsive position-relative mt30"
                    loading="lazy"
                    alt="Real-Time Syncing"
                  />
                </div>
              </div>

              <div
                className="max-width950 common-shadow common-box"
                style={{ marginTop: "24px" }}
              >
                <div className="grid-auto-fit align-items-center">
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Advanced Search Filters
                    </h3>
                    <p className="roboto-regular heading16px">
                      Leverage LinkedIn’s advanced search features to pinpoint
                      the exact professionals you need, whether by industry,
                      location, or company size.
                    </p>
                  </div>
                  <div>
                    <img
                      src={AdvanceSearchFilter}
                      class="img-responsive position-relative"
                      loading="lazy"
                      alt="Advanced Search Filters"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default LinkedingExtPage;
